import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { QuestionOption, QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { IQuestionOptionForm } from './question-form-group.interface';
import { QuestionForm } from './question-form.model';
import { QuestionOptionForm } from './question-option-form.model';

export class QuestionFormRanking extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('type').setValue(QuestionType.Ranking);
    (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.Ranking);
    this.patchOptions(question.options);
  }

  private extendFormGroup(): void {
    this.form.addControl('maxLength', new FormControl<number>(0));
    this.form.addControl('minLength', new FormControl<number>(1));
    this.form.addControl('randomizedOptionsInd', new FormControl<boolean>(false));
    this.form.addControl('options', new FormArray<FormGroup<IQuestionOptionForm>>([]));
    this.form.addControl('useOtherInd', new FormControl<boolean>(false));

    this.form.get('requiredInd').valueChanges.subscribe((requiredInd: boolean) => {
      if (requiredInd && this.form.get('minLength').value === 0) {
        this.form.get('minLength').setValue(1);
      }
    });
  }

  private patchOptions(options: QuestionOption[]): void {
    if (!options || options.length === 0) {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
      return;
    }
    options.forEach((option) => {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }
}
